import request from '@/utils/httpRequest'

export default class DeratedApplyService {
    queryById(id) {
        return request({
            url: '/finance/wuyeFinanceDerated/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    list (params) {
        return request({
            url: '/finance/wuyeFinanceDerated/getDeratedList',
            method: 'get',
            params: params
        })
    }

    startFlow (params) {
        return request({
            url: '/finance/wuyeFinanceDerated/startFlow',
            method: 'post',
            data: params
        })
    }
}